<!--
A carousel item, used in the homepage
-->
<template>
    <span class="carouselItem" @click="handleClick">
        <slot></slot>
    </span>
</template>
<script setup>
import { defineEmits } from 'vue';

const emit = defineEmits(['itemClick'])

function handleClick(clickEvent) {

  const classSlide = clickEvent.target.closest('.carouselItem')

  if(classSlide) {
    emit('itemClick', clickEvent);
  }
  
}

</script>
<style lang="scss" scoped>

.itemSelected {
  opacity: 1;
  flex: 1;
}
.itemNotSelected {
  z-index: 1;
  flex: 0 0 auto;
}
</style>
